/**
 * 权益补贴 -- 结算方式
 */
export default function subsidySettleWay(val) {
    let str = '';
    switch (val) {
    case 'OFF_LINE':
        str = '线下转账';
        break;
    case 'OIL':
        str = '汽油';
        break;
    default:
        break;
    }
    return str;
}
